import { forwardRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGS, DEFAULT_LANG, localizedPath, stripLangPrefix } from "../i18n";

/**
 * <LocalizedLink to="/experiente"> — automatically prefixes the current language.
 */
export const LocalizedLink = forwardRef(function LocalizedLink(
  { to, children, ...rest },
  ref
) {
  const { i18n } = useTranslation();
  const lang = i18n.language || DEFAULT_LANG;
  return (
    <Link ref={ref} to={localizedPath(to, lang)} {...rest}>
      {children}
    </Link>
  );
});

/**
 * Hook that returns a function to switch language while keeping the current
 * path. Also persists the choice.
 */
export function useLangSwitcher() {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  return (nextLang) => {
    if (!SUPPORTED_LANGS.includes(nextLang)) return;
    const cleanPath = stripLangPrefix(location.pathname);
    const nextPath = localizedPath(cleanPath, nextLang) + location.search + location.hash;
    try {
      localStorage.setItem("apuseni_lang", nextLang);
    } catch { /* noop */ }
    i18n.changeLanguage(nextLang);
    navigate(nextPath);
  };
}
